<template lang="html">
  <div class="toc">

    <div class="toc__close" @click="emitClick()">
      <img class="topbar__icon" :src="$getImagePath('images', 'icon_close.svg')" :alt="$getTrans('close', 'de')" :title="$getTrans('close', 'de')">
    </div>

    <h2 class="toc__header">
      {{ $getTrans('header', 'de', 'cookiepoliciy') }}
    </h2>
    <ul class="toc__list">
      <li
        v-for="(item, key, index) in $getTrans('cookieinfo', 'de', 'cookiepoliciy')"
        class="toc__list--item">
        <h3 class="toc__list--title">{{ key }} {{ item.header }}</h3>
        <p class="toc__list--content">
          {{ item.content }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  import api from '@/api'
  import EventBus from '@/eventbus'

  export default {
    name: 'Toc',
    data() {
      return {
        windowWidth: 0,
        index: 0
      }
    },
    mounted() {
      // Get the current viewport width
      this.windowWidth = this.getWindowWidth()

      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth)
        // Get current viewport width if user changes it
        this.getWindowWidth()
      })

      // Prevent parent container of scrolling
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'

      // Hide modal with esc key
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.emitClick()
        }
      })

      document.querySelector('.topbar').style.display = 'none'
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth)
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
      window.removeEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.emitClick()
        }
      })
      document.querySelector('.topbar').style.display = 'block'
    },
    methods: {
      emitClick() {
        this.$emit('closeToc', true);
      },
      getWindowWidth(event) {
        // console.log(document.documentElement.clientWidth);
        this.windowWidth = document.documentElement.clientWidth
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cookiepolicy/Cookiepolicy.vue